import {NgModule} from '@angular/core';
import {APOLLO_OPTIONS} from 'apollo-angular';
import {ApolloClientOptions, InMemoryCache} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import { environment } from '@environment';

const uri = environment["graphqlUrl"]

export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
  return {
    link: httpLink.create({uri}),
    cache: new InMemoryCache({
      // Remove __typename from response
      addTypename: false,
      typePolicies: {
        RestrictedUser: {
          // RestrictedUser sometimes comes with id=null (free text entry)
          // This is to have apollo resolve these into unique values
          keyFields: ["id", "fullName"],
        }
      }
    }
    ),
    // defaultOptions: {
    //   query: {
    //     errorPolicy: 'all'
    //   }
    // }
  };
}

@NgModule({
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class  GraphQLModule {}
